module.exports = __webpack_public_path__ + "media/img/pages/companies/syngenta-8d86ec5ca858c02bec681db1ca15e649.png";